import axios from 'axios';
import {getAuthHeader} from '../global_helpers/authHeader.js';
import {getTPAID} from '../global_helpers/sessionReturn.js';
import { Proposal } from './dataModels.js';

const state = {
    proposalBeingEdited: new Proposal(),

    proposalListItems: null,
    proposaloptions: {
        externalwholesaler: [],
        
        brokerRadioList: [],
        brokerDropDownList: [],
        brokerForm: null,
        
        advisorRadioList: [],
        advisorDropDownList: [],
        advisorBrokerList: [],
        advisorForm: null,
    },
    brokerObj: null,
    advisorObj: null,
    loiList: null,
    statusList: null,
    proposalHeaders: null,   
};

const getters = {
    getProposalBeingEdited: (state) => state.proposalBeingEdited,
    getProposalListItems: (state) => state.proposalListItems,
    wholesalerOptions: (state) => state.proposaloptions.externalwholesaler,    
    getLoiList: (state) => state.loiList,
    getStatusList: (state) => state.statusList,
    proposalHeaders: (state) => state.proposalHeaders,
};

const actions = {
    
    async getProposal({commit}, proposal_id){
        let authHeader = getAuthHeader();
        axios.get("/proposal/?proposal_id="+proposal_id, authHeader).then((res) => {
            commit('setProposal', res.data);
        })
    },
    
    async saveProposals({dispatch}, proposals){
        let authHeader = getAuthHeader();
        
        axios.post('/proposal/save/', proposals, authHeader)
        
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error when trying to render your proposals!', {root: true});
        });
    },
    
    async loadWholesalers({dispatch, commit}, data){
        let authHeader = getAuthHeader();
        axios.get('/wholesaler/ddl/?entity_type='+data.entity.type+"&entity_id="+data.entity.id+"&rk_id="+data.rk_ids, authHeader)
        
        .then((res) => {
            commit('setProviders', res.data)
        })
        
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'Failed to load providers for revenue share program.', {root: true});
        })
    },
    
    async getProposalList({commit}, entity) {
        console.log('getProposalList')
        // set local variable for func to access auth token
        let authHeader = getAuthHeader();
        // returns an object array
        axios.get("/proposal/list/?"+entity.type+"_id="+entity.id, authHeader).then((res) => {
            console.log('getProposalList res');
            console.log(res.data);
            commit('setProposalList', res.data);
        })
    },

    async clearProposalList({commit}){
        console.log('clearProposalList')
        commit('clearProposalList');
    },
    
    async getWholesalerOptions({commit}, urlParam){
        let authHeader = getAuthHeader();
        axios.get("/wholesaler/?rk_id="+urlParam, authHeader).then((res) => {
            commit('setWholesalerOptions', res.data);
        })
    },
    
    async clearWholesalerOptions({commit}){
        commit('clearWholesalerOptions')
    },
    
    async updateListHeader({dispatch}, obj){
        let authHeader = getAuthHeader();
        let tpa_id = getTPAID()
        let disp_obj = {
            type: 'tpa',
            id: tpa_id
        }
        axios.post("/proposal/list/", obj, authHeader)
        
        .then((res) => {
            dispatch('getProposalList', disp_obj)
            dispatch('raiseMessage','Successfully updated client opportunity!',{root: true})
            console.log(res.data)
        })
        
        .catch(dispatch('raiseMessage','Failed to update client opportunity!', {root: true}))
    },
    
    async getStatusList({commit}){
        let authHeader = getAuthHeader();
        axios.get('/planstatus/', authHeader).then((res) => {
            commit('setStatusList', res.data)
        })
    },
    
    async getLoiList({commit}){
        let authHeader = getAuthHeader();
        axios.get('/loi/', authHeader).then((res) => {
            commit('setLoiList',res.data)
        })
    },
    
    async addNewProposalFromList({dispatch}, item) {
        let authHeader = getAuthHeader();
        let proposal_id = item.proposals[0].proposal_id;
        axios.get("/proposal/?proposal_id="+proposal_id, authHeader).then((res) => {
            dispatch('addNewProposalFromList_Helper', res.data);
        });
    },
    
    async deleteProposalFromList({dispatch}, proposal_id){
        let authHeader = getAuthHeader();
        let tpa_id = getTPAID();
        let entity = {
            type: "tpa",
            id: tpa_id
        }
        axios.delete("/proposal/?proposal_id="+ proposal_id, authHeader).then(
                dispatch('raiseMessage', 'Successfully Deleted Proposal', {root: true}),
                dispatch('getProposalList', entity)
        )
        .catch(err => {
            console.log(err)
            dispatch('raiseMessage','Oh no! There was an error deleting your proposal!')
        })
    },
    
    async setProposalForAA({commit}, obj){
        commit('setProposalDetailForAA', obj);
    },
    
    async exportProposalList(state, entity) {
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let auth = {
            Authorization: authToken
        };
    
        axios({
            method: 'get',
            url: "/proposal/list/excel/?"+entity.type+"_id="+entity.id,
            responseType: 'blob',
            headers: auth
        })
        .then((res) => {
            var url = window.URL.createObjectURL(res.data);
              var a = document.createElement('a');
              a.href = url;
              a.download = "proposal_list_export.xlsx";
              document.body.appendChild(a);
              a.click();
              a.remove();          
        }).catch((res) => {
            console.error("Could not download the Excel report from the backend.", res);
        });
    },

    async downloadProposalPDF(state, item){
        let proposal_id = item.proposal_id;
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let auth = {
            Authorization: authToken
        };
        if(item.file_name === undefined){
            let file = item.proposal_file_name;
            
            axios({
                method: 'get',
                url: "/proposal/pdf/?proposal_id="+proposal_id,
                responseType: 'blob',
                headers: auth
            })
            .then((res) => {
                var url = window.URL.createObjectURL(res.data);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = file+".pdf";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();          
            }).catch((res) => {
                console.error("There was an error downloading the document.", res);
            });
            
        } else {
            let file = item.file_name
            axios({
                method: 'get',
                url: "/proposal/pdf/?proposal_id="+proposal_id,
                responseType: 'blob',
                headers: auth
            })
            .then((res) => {
                var url = window.URL.createObjectURL(res.data);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = file+".pdf";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();          
            }).catch((res) => {
                console.error("Could not download the PDF report from the backend.", res);
            });
        }
    },

    async downloadProposalDOCX(state, item){
        let proposal_id = item.proposal_id;
        let token = sessionStorage.getItem('token');
            let authToken = "Token "+token;
            let auth = {
                Authorization: authToken
            };
        if (item.file_name === undefined) {
            let file = item.proposal_file_name
            axios({
                method: 'get',
                url: "/proposal/docx/?proposal_id="+proposal_id,
                responseType: 'blob',
                headers: auth
            })
            .then((res) => {
                var url = window.URL.createObjectURL(res.data);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = file+".docx";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();          
            }).catch((res) => {
                console.error("There was an error downloading the document.", res);
            });
            
        } else {
            let file = item.file_name
            
            axios({
                method: 'get',
                url: "/proposal/docx/?proposal_id="+proposal_id,
                responseType: 'blob',
                headers: auth
            })
            .then((res) => {
                var url = window.URL.createObjectURL(res.data);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = file+".docx";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();          
            }).catch((res) => {
                console.error("Could not download the docx report from the backend.", res);
            });
        }
        
        
    },
};

const mutations = {    
    setProposal(state, data){
        console.log('setProposal mutation');
        console.log(data)
        state.proposalBeingEdited = data;
    },

    clearProposalList(state){
        state.proposalListItems = null;
    },
    
    setProposalList(state, items){
        state.proposalListItems = items;
    },
    
    setLoiList(state, data){
        state.loiList = data
    },
    
    setProviders(state, items){
        state.providersListItems = items;
    },
    
    clearPlanOpportunityState(state){
        state.planOpportunity = null;
    },
    
    clearWholesalerOptions(state){
        state.proposaloptions.externalwholesaler = [];
    },
    
    setWholesalerOptions(state, data){
        let i
        console.log(data)
        for(i=0; i< data.length; i++){
            state.proposaloptions.externalwholesaler.push(data[i])
        }
    },
    
    setStatusList(state, data){
        state.statusList = data
    },
    
    setReturnMessage(state, message) {
        if (state.proposalListReturnMessages.length === 0){
            state.proposalListReturnMessages.push(message);    
        } else {
            state.proposalListReturnMessages = [];
            state.proposalListReturnMessages.push(message);
        }
        
    },
    
    deleteProposal(state, data){
        let planop = state.proposalListItems.filter(function(planop){
           return planop.plan_opportunity_id === data.details.plan_opportunity_id 
        });
        console.log(data);
        planop.proposals = planop.filter(function(proposal){
           return proposal.proposal_id !== data.item.proposal_id
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};